const AddForm = require('../ui/addform');
const Tactic = require('./tactic');
const CollectionManager = require('../ui/collection');
const ToggledIntro = require('../ui/toggled-intro');
const ToggledMenu = require('../ui/toggled-menu');
const template = require('./strategy.tpl').default;

module.exports = DomClass(template, function Strategy() {
    var _t = this;

    this.tactics = [];
	this.cardCount = 0;

	var onchange = on(this, 'change');

	this.toJSON = () => ({
		tactics: this.tactics
	});

	this.sortLink.onclick = function() {
		_t.tactics.sort(function(a,b) {
			return a.compareTo(b);
		});
		on(manager, 'change').fire();
	};

	this.expandLink.onclick = function() {
		_t.tactics.forEach(function(c) { c.show(); });
	};

	this.collapseLink.onclick = function() {
		_t.tactics.forEach(function(c) { c.hide(); });
	};

	this.editRawLink.onclick = () => {
		typeof this.editRaw === 'function' && this.editRaw();
	};

	this.recount = function(deck) {
		_t.cardCount = deck.count;
		_t.tactics.forEach(function(tactic) {
			tactic.recount(deck);
		});
	};
	
	this.lock = function() {
		this.classList.add('locked');
		this.tactics.forEach(function(tactic) { tactic.lock(); });
		this.editRawLink = 'view raw';
	};

	this.unlock = function() {
		this.classList.remove('locked');
		this.tactics.forEach(function(tactic) { tactic.unlock(); });
		this.editRawLink = 'edit raw';
	};

	var store = null;
    var manager = new CollectionManager(
		this.tactics, this.addform, Tactic, store
	);
	on(manager, 'change', function() {
		onchange.fire(_t);
	});
    manager.restore();
	
	ToggledIntro.call(this.intro, manager);
	ToggledMenu.call(this.menu, manager);
	
});
